import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from './toast.service';
import { ToastModule } from 'ng2-toastr';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    ToastModule.forRoot()
  ],
  providers: [
    ToastService
  ]
})

export class CoreModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/core/core.module.ts